const pageLoadingKey = Symbol('pageLoading')

// Each mounted page source owns its entry, so parallel requests cannot clear one another.
export function providePageLoading() {
  const sources = reactive(new Set())
  provide(pageLoadingKey, (source, loading) => {
    if (loading) sources.add(source)
    else sources.delete(source)
  })
  return computed(() => sources.size > 0)
}

// Without an Admin layout, shared components retain their local loading indicator.
export function usePageLoading(loading, enabled = true) {
  const update = inject(pageLoadingKey, null)
  const resolve = (value) => (typeof value === 'function' ? value() : unref(value))
  const usesPageLoading = computed(() => Boolean(update && resolve(enabled)))

  if (update) {
    const source = Symbol('loadingSource')
    watchEffect(() => update(source, usesPageLoading.value && Boolean(resolve(loading))), { flush: 'sync' })
    onScopeDispose(() => update(source, false))
  }

  return usesPageLoading
}
